export interface RoutineConfig {
  title: string;
  routineButtonText?: string;
  issuePrefix?: string;
  reportOnException?: boolean;
  inventory?: boolean;
  uom?: string;
  autoPrompt?: boolean;
  disabled?: boolean;
}

export interface SingleStateConfig extends RoutineConfig {
  instructions: string;
}
